import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const ManuelMotorlutentePage = () => {
  useEffect(() => {
    document.title = 'Manuel Motorlu Tente Servisi - İzmir Tente Tamir | Motor Tamiri';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde manuel ve motorlu tente servisi. Motor arızaları, kumanda sorunları ve motorlu tente sistemlerine profesyonel çözümler. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' },
    { title: 'Tente Yenileme', link: '/hizmetler/tente-yenileme' },
    { title: 'Branda Değişimi', link: '/hizmetler/branda-degisimi' },
    { title: 'Körüklü Tente Tamiri', link: '/hizmetler/koruklu-tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/ac027f5e4ae588ebb18f42f29f87c58c.jpg"
            alt="Manuel Motorlu Tente Servisi"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Manuel Motorlu Tente Servisi</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Manuel Motorlu Tente Servisi
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Modern yaşamın konforunu artıran motorlu tente sistemleri, kullanım kolaylığı ve pratiklik sağlar. İzmir Tente Tamir olarak, hem motorlu tente sistemlerinin tamir ve bakımını yapıyor hem de manuel tentelerinizi motorlu sisteme dönüştürüyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Motorlu Tente Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Motorlu tente, elektrik motoru ile çalışan ve uzaktan kumanda veya anahtar yardımıyla açılıp kapanan tente sistemidir. Manuel kol çevirme zahmetini ortadan kaldırır ve tek tuşla tentenizi kontrol etmenizi sağlar. Özellikle büyük tenteler için ideal bir çözümdür.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Motorlu Tente Sistemlerinde Karşılaşılan Sorunlar</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Motorlu tente sistemlerinde yaşanabilecek sorunlar:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Motor Arızası:</strong> Motor çalışmıyor veya anormal sesler çıkarıyor</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kumanda Sorunları:</strong> Uzaktan kumanda çalışmıyor veya sinyal vermiyor</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Elektrik Bağlantı Problemleri:</strong> Kablo hasarları veya bağlantı kopuklukları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Limit Ayar Bozukluğu:</strong> Tente tam açılmıyor veya kapanmıyor</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yavaş Hareket:</strong> Motor yavaş çalışıyor veya takılıyor</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Motorlu Tente Servis Hizmetlerimiz</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                İzmir Tente Tamir olarak sunduğumuz motorlu tente servisleri:
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Motor Tamiri ve Değişimi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Arızalı motorları tamir ediyor veya yenileriyle değiştiriyoruz. Kaliteli ve dayanıklı motor markaları kullanıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Kumanda Programlama ve Değişimi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Uzaktan kumandaları programlıyor, pil değişimi yapıyor veya yeni kumanda temin ediyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Elektrik Sistemi Kontrolü</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Tüm elektrik bağlantılarını kontrol ediyor, hasarlı kabloları değiştiriyor ve güvenli bağlantı sağlıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Limit Ayarı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Tentenizin tam açılma ve kapanma noktalarını hassas bir şekilde ayarlıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Manuel Tenteyi Motorlu Sisteme Dönüştürme</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Mevcut manuel tentenize uygun motor sistemi seçiyor ve profesyonelce montajlıyoruz. Böylece tentenizi tek tuşla kontrol edebilirsiniz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Motorlu Tente Sisteminin Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kullanım Kolaylığı:</strong> Tek tuşla açılıp kapanır</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Zaman Tasarrufu:</strong> Hızlı ve pratik kullanım</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Fiziksel Güç Gerektirmez:</strong> Yaşlılar ve çocuklar için ideal</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Akıllı Kontrol:</strong> Rüzgar ve güneş sensörleri ile otomatik çalışma</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzun Ömür:</strong> Mekanizmaya daha az yük bindirir</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Servis Süreci</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Motorlu tente servis sürecimiz şu adımlardan oluşur:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Arıza Tespiti:</strong> Motor ve elektrik sistemini detaylı olarak inceliyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Fiyat Teklifi:</strong> Yapılacak işlemler ve maliyetler hakkında bilgi veriyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Tamir/Montaj:</strong> Onayınızın ardından işlemi gerçekleştiriyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Test ve Eğitim:</strong> Sistemi test ediyor ve kullanım konusunda bilgilendirme yapıyoruz</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden Bizi Tercih Etmelisiniz?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzman Kadro:</strong> Motorlu tente sistemleri konusunda deneyimli teknisyenlerimiz var</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Motor:</strong> Güvenilir ve dayanıklı motor markaları kullanıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Servis:</strong> Acil durumlarda aynı gün müdahale</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uygun Fiyat:</strong> Şeffaf ve rekabetçi fiyatlandırma</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Motorlu tente servisi için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ManuelMotorlutentePage;